import React from 'react';
import { FUSE_TYPE_FORMATS, FUSE_SIZES } from '../../common/FuseboxData.mjs';

const SKIP_TYPES = ['CALIBRATION', 'other', 'fuse-strip-hsb'];

// Define the default order for component types
const COMPONENT_TYPE_ORDER = [
  "svg",
  "battery-terminal",
  "connector",
  "fusepuller",
  "relay",
  "misc",
];

// Helper function to sort the component types per the default order first, then the rest alphabetically
function getOrderedTypes(typeFormats) {
  const allTypes = Object.keys(typeFormats).filter(
    type => !SKIP_TYPES.includes(type) && typeFormats[type]
  );

  const prioritizedTypes = COMPONENT_TYPE_ORDER.filter(type => allTypes.includes(type));
  const remainingTypes = allTypes
    .filter(type => !COMPONENT_TYPE_ORDER.includes(type))
    .sort();

  return [...prioritizedTypes, ...remainingTypes];
}

const SCALE_FACTOR = 5;

function getSizeDimensions(type, format) {
  let sizeRule = FUSE_SIZES[type]?.[format] || FUSE_SIZES[type]?.['all'];
  if (sizeRule?.width && sizeRule?.height) {
    let { width, height, pngW = 1, pngH = 1 } = sizeRule;

    return { 
      width: sizeRule.width, 
      height: sizeRule.height,
      pixelWidth: sizeRule.width * pngW * SCALE_FACTOR,
      pixelHeight: sizeRule.height * pngH * SCALE_FACTOR
    };
  }
  return null;
}

export default function ComponentPickerModal({ onSelect, onClose }) {
  const orderedTypes = getOrderedTypes(FUSE_TYPE_FORMATS);

  return (
    <div style={{ overflowY: 'auto', minWidth: '500px' }}>
      {orderedTypes.map(type => {
        const formats = FUSE_TYPE_FORMATS[type];
        if (SKIP_TYPES.includes(type) || !formats) return null;

        return (
          <div key={type} className={'fusebox-diagram mb-1 border-top border-white border-1 p-1'}>
            <div className={' d-flex flex-wrap'} style={{ gap: '8px' }}>
              <div className={'font-weight-bold text-white text-center'}>{type}:</div>
              {formats.map((format, i) => {
                let formatClass = format ? `${type}-${format}` : '';
                let { width, height, pixelWidth, pixelHeight } = getSizeDimensions(type, format) || {};

                let zoom = Math.min(1, 200/Math.max(pixelWidth, pixelHeight));
                return (
                  <div
                    key={format || '__default__' + i}
                    className={'text-center cursor-pointer mr-1'}
                    style={{}}
                    onClick={() => onSelect({ type, format })}
                  >
                    <div className={'small text-muted'} style={{ lineHeight: '1.2', marginBottom: '5px' }}>
                      {format || '(default)'}
                    </div>

                    <span
                      className={`d-inline-block fuse fuse-${type} ${formatClass} fuse-amp-40`}
                      style={{
                        width: (pixelWidth || 100) + 'px',
                        height: (pixelHeight || 50) + 'px',
                        zoom: zoom,
                        position: 'relative',
                        border: 'solid rgba(255,255,255,0.1) 1px'
                      }}
                    ></span>

                    <div className={'small text-secondary'} style={{ fontSize: '10px' }}>
                      {width || '-'}×{height || '-'}mm
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
